<template>
    <div>
        <YesNoModal ref="YesNoModal" />
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <Loader ref="Loader"></Loader>
        <v-container fluid grid-list-xs>
            <!-- <v-layout>
            <v-flex xs12 sm12 text-xs-center>
                <h3 style="font-size: 2em;">{{ TranslateText("User Maintenance")}}</h3>
                <br>
            </v-flex>
        </v-layout> -->
            <v-layout justify-center wrap>
                <v-flex md12>
                    <v-card>
                        <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="[25,50,75,100]">
                            <template slot="no-data">
                                {{TranslateText('There are no records')}}
                            </template>
                            <template slot="no-results">
                                {{TranslateText('No matching records found')}}
                            </template>
                            <template slot="headerCell" slot-scope="{ header }">
                                <span class="subheading font-weight-light text-success text--darken-3" v-text="header.text" />
                            </template>
                            <template slot="items" slot-scope="{ item }">
                                <td>{{ item.Title }}</td>
                                <td>{{ item.FirstName }}</td>
                                <td>{{ item.LastName }}</td>
                                <td>{{ item.ContactEmail }}</td>
                                <td>{{ item.ContactTel }}</td>
                                <!-- <td style="float:right;">
                                    <v-menu dense bottom left>
                                        <v-btn small slot="activator" color="primary" dark>
                                            <v-icon>settings</v-icon>
                                        </v-btn>

                                        <div v-if="HasAccess('USER_MANAGEMENT', 'MODIFY') || HasAccess('USER_MANAGEMENT', 'DELETE')">
                                            <v-list dense v-for="(action, index) in actionItems" :key="index">
                                                <v-list-tile @click="PerformOperation(action, item)" v-if="action.access == true">
                                                    <v-list-tile-action>
                                                        <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </div>
                                        <div v-else>
                                            <v-list dense>
                                                <v-list-tile>
                                                    <v-list-tile-title>{{ TranslateText(`You have no options
                                                        available`)}}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </div>
                                    </v-menu>
                                </td> -->
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            let self = this;

            return {
                actionItems: [{
                        type: 'modify',
                        title: self.TranslateText('Modify'),
                        access: self.HasAccess('USER_MANAGEMENT', 'MODIFY'),
                        icon: 'edit'
                    },
                    {
                        type: 'delete',
                        title: self.TranslateText('Delete'),
                        access: self.HasAccess('USER_MANAGEMENT', 'DELETE'),
                        icon: 'delete'
                    }
                ],
                headers: [{
                        sortable: true,
                        text: self.TranslateText('Title'),
                        value: 'Title'
                    },
                    {
                        sortable: true,
                        text: self.TranslateText('First name'),
                        value: 'FirstName'
                    },
                    {
                        sortable: true,
                        text: self.TranslateText('Last name'),
                        value: 'LastName'
                    },
                    {
                        sortable: true,
                        text: self.TranslateText('Email address'),
                        value: 'ContactEmail'
                    },
                    {
                        sortable: true,
                        text: self.TranslateText('Contact Telephone Number'),
                        value: 'ContactTel'
                    },

                ],
                items: [],
                // search: null
            }
        },
        props: {
            search: String
        },
        mounted() {
            let self = this;
            self.FetchData();
        },
        methods: {
            FetchData() {
                let self = this;
                self.$refs.Loader.show(true);
                self.$refs.Loader.setText(this.TranslateText('Loading users...'));
                self.get('SystemUser')
                    .then(response => {
                        self.$refs.Loader.hide();
                        self.items = response.data;
                        console.log(self.items)
                    })
                    .catch(error => {
                        self.$refs.Loader.hide();
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(error.toString());
                    })
            },
            PerformOperation(action, item) {
                let self = this;
                switch (action.type.toUpperCase()) {
                    case "MODIFY":
                        {
                            self.modifyitem(item);
                        }
                        break;
                    case "DELETE":
                        {
                            self.deleteItem(item);
                        }
                        break;
                }
            },
            modifyitem(item) {
                let self = this;

                self.$router.push('/user/modify/' + item.ID);
            },
            deleteItem(item) {
                let self = this;
                self.$refs.YesNoModal.show(self.TranslateText('Are you sure you want to delete this user?'), function (
                    yes) {
                    if (yes == true) {
                        self.$refs.Loader.show(true);
                        self.$refs.Loader.setText(this.TranslateText('Deleting user...'));
                        self.delete(`SystemUser?id=${item.ID}`)
                            .then(result => {
                                self.$refs.Loader.hide();
                                if (result.data == true) {
                                    var index = self.items.indexOf(item);
                                    if (index > -1) {
                                        self.items.splice(index, 1);
                                    }
                                }
                            })
                            .catch(error => {
                                self.$refs.Loader.hide();
                                self.$refs.ErrorModal.show();
                                self.$refs.ErrorModal.setText(error.toString());
                            })
                    }
                })
            }
        }
    }
</script>